import AddDashboardComponent from './AddDashboardComponent'
import { AccessoryDrawerDisplay } from '@edge/spark/io-dashboards'

interface AccessoryPane {
    headerText: string
    Component: React.FC
    enumValue: AccessoryDrawerDisplay
    widthInPixels: number
    routesToShow?: string[]
}

export const AccessoryDrawerPanes: AccessoryPane[] = [
    {
        headerText: 'Add Card to Dashboard',
        Component: AddDashboardComponent,
        enumValue: AccessoryDrawerDisplay.WidgetConfig,
        widthInPixels: 300,
        routesToShow: ['/'],
    },
]

export default AccessoryDrawerPanes
